import { useGetLazyPaginatedDeviceTemplates } from "./useGetLazyPaginatedDeviceTemplates";

export const useDeviceTemplatesTableRows = () => {
  const { data, loading } = useGetLazyPaginatedDeviceTemplates();

  const rows =
    data?.getDeviceTemplates?.items.map((item, index) => {
      return {
        id: item?.id,
        rowId: item?.id ?? `${index}`,
        name: item?.name,
        templateData: item?.templateData,
        numberOfNodes: item?.numberOfNodes,
      };
    }) ?? [];

  return { rows, loading };
};
